export enum RoleTypes {
    admin = "admin",
    user = "user",
}
